import React from 'react';
import { Typography } from '@vtblife/uikit';
import classname from '@search/classname/src';

import './styles.css';

const cn = classname.bind(null, 'NewBuildingSectionHeading');

export const NewBuildingSectionHeading: React.FC<{
    title: string;
    postfix?: string;
    subtitle: string;
    seoTitle?: string | null;
}> = ({
    title,
    postfix,
    subtitle,
    seoTitle
}) => (
    <Typography
        variant='h2'
        tag='h2'
        bold
        className='reset-h-tags'
    >
        {title}{postfix ? ` ${postfix}` : ''}
        <Typography
            variant='primary-alone'
            color='secondary'
            className={cn('sectionSubtitle')}
        >
            {subtitle} {seoTitle}
        </Typography>
    </Typography>
);
